import {createSelector} from '@reduxjs/toolkit';
import {useSelector} from 'Provider';
import {AppState} from 'store';

import {AffiliateState} from './affiliate.reducer';

export const affiliateState = (state: AppState): AffiliateState =>
  state.affiliate;

export const affiliateAccountListMapSelector = createSelector(
  affiliateState,
  state => state.affiliateAccountListMap
);

export const partnerListSelector = createSelector(
  affiliateState,
  state => state.partners
);

export const getAccountDetailsStateMapSelector = createSelector(
  affiliateState,
  state => state.getAccountDetailsStateMap
);

export const partnerTierBracketsSelector = createSelector(
  affiliateState,
  state => state.partnerTierBrackets
);

export const initiateExchangeCurrencyStateSelector = createSelector(
  affiliateState,
  state => state.initiateExchangeCurrencyState
);

export const initiateExchangeCurrencyErrorSelector = createSelector(
  affiliateState,
  state => state.initiateExchangeCurrencyError
);

export const getAccountAffiliateMappingsStateSelector = createSelector(
  affiliateState,
  state => state.getAccountAffiliateMappingsState
);
